import script from "./Comment.vue?vue&type=script&setup=true&lang=js"
export * from "./Comment.vue?vue&type=script&setup=true&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=46253d3a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46253d3a"]])

export default __exports__